exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-common[data-v-4d593601] {\n  margin-right: 5px;\n}\n", ""]);

// exports
